<template>
  <o-section v-if="field_visible" :title="field_label" not-closable>
    <f-widget-list
      :item="the_item[field.code]"
      @change="change"
      @error="handleError"
      :fields="field.fields"
      :design="design"
      :disabled="is_disabled"
      :selector="selector"
      :form-state="formState"
      :form-context="nestedFormContext"
      @fields-change="fieldsChanged"
    ></f-widget-list>
  </o-section>
</template>

<script>
import { setter } from "../setter";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";
import FWidgetList from "../FWidgetList.vue";
import ContainerWidgetMixin from "../ContainerWidgetMixin.js";

export default {
  name: "SectionWidget",
  mixins: [ContainerWidgetMixin],
  components: { FWidgetList, OSection },
  created: function () {
    if (this.item && !(this.field.code in this.item)) {
      setter(this, this.item, this.field.code, {});
    }
  },
};
</script>

<style scoped></style>
